import FiltersProducts from "./FiltersProducts";

export default class FilterTag extends HTMLDivElement {
    constructor() {
        super();
        this.fiterName = this.dataset.filterName;
        this.fiterValue = this.dataset.filterValue;
        this.closeButton = this.querySelector('[data-filter-tag-close-button]');
    }

    connectedCallback() {
        this.watch();
    }

    /**
     * Écoute les événements.
     */
    watch() {
        this.closeButton.addEventListener('click', this.removeFilter.bind(this));
    }

    /**
     * Désactive des filtres la valeur correspondant au tag.
     */
    removeFilter() {
        const filterProducts = new FiltersProducts();
        filterProducts.removeFilter(this.fiterName, this.fiterValue);
    }
}
